/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { colors, Text } from 'bold-ui'
import { Fragment } from 'react'

interface ConsultaSeguimentoPerguntaHeaderTitleProps {
  prefix?: string
  sufix: string
}

export function ConsultaSeguimentoPerguntaHeaderTitle(props: Readonly<ConsultaSeguimentoPerguntaHeaderTitleProps>) {
  const { prefix, sufix } = props

  return (
    <Fragment>
      <Text fontSize={1} fontWeight='bold' style={styles.grayTextColor}>
        “{prefix ? `${prefix} ` : ''}
      </Text>
      <Text fontSize={1} textDecoration='underline' fontWeight='normal' style={styles.grayTextColor}>
        ({prefix ? 'perguntar' : 'Perguntar'} usando o nome da criança)
      </Text>
      <Text fontSize={1} fontWeight='bold' style={styles.grayTextColor}>
        {sufix}”
      </Text>
    </Fragment>
  )
}

const styles = {
  grayTextColor: css`
    color: ${colors.gray.c10};
  `,
}
